export default __webpack_public_path__ + "static/AlphaPoster-a0064e3d4b68c4dad5f465e4ed24d6ce.png";